import React from 'react';
import './index.scss';
import ProfileForm from './ProfileForm';
import ProfileImage from './ProfileImage';


const UserProfile = () => {
    return (
        <div className="user-profile-blc d-flex">
            <div className="left-col">
                <ProfileImage />
            </div>
            <div className="right-col flex-fill">
                <ProfileForm />
            </div>
        </div>
    );
}

export default UserProfile;